export function getRedirectURL() {
  if (typeof window !== 'undefined') {
    return new URL(document.location.href).origin + '/';
  } else {
    // Running on the server
    return new URL(process.env.NEXT_PUBLIC_AUTH0_REDIRECT_URI).origin + '/';
  }
}
